var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditIcon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.004,
    viewBox: "0 0 22 22.004",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8025",
    "data-name": "Group 8025",
    transform: "translate(-533.5 -438.401)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10010",
    "data-name": "Rectangle 10010",
    width: 22,
    height: 22.004,
    rx: 2,
    transform: "translate(533.5 438.401)",
    fill: "#e5eaed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pencil-square",
    transform: "translate(535.047 443.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M14.769,1.848a.468.468,0,0,1,0,.661l-.977.978L11.92,1.614,12.9.637a.468.468,0,0,1,.662,0l1.211,1.211Zm-1.639,2.3L11.258,2.275,4.879,8.655a.468.468,0,0,0-.113.184L4.012,11.1a.234.234,0,0,0,.3.3l2.26-.754a.468.468,0,0,0,.184-.112l6.379-6.38Z",
    transform: "translate(0 0)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMi4wMDQiIHZpZXdCb3g9IjAgMCAyMiAyMi4wMDQiPgogIDxnIGlkPSJHcm91cF84MDI1IiBkYXRhLW5hbWU9Ikdyb3VwIDgwMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01MzMuNSAtNDM4LjQwMSkiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV8xMDAxMCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgMTAwMTAiIHdpZHRoPSIyMiIgaGVpZ2h0PSIyMi4wMDQiIHJ4PSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1MzMuNSA0MzguNDAxKSIgZmlsbD0iI2U1ZWFlZCIvPgogICAgPGcgaWQ9InBlbmNpbC1zcXVhcmUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUzNS4wNDcgNDQzLjAxMikiPgogICAgICA8cGF0aCBpZD0iUGF0aF8xMDk4IiBkYXRhLW5hbWU9IlBhdGggMTA5OCIgZD0iTTE0Ljc2OSwxLjg0OGEuNDY4LjQ2OCwwLDAsMSwwLC42NjFsLS45NzcuOTc4TDExLjkyLDEuNjE0LDEyLjkuNjM3YS40NjguNDY4LDAsMCwxLC42NjIsMGwxLjIxMSwxLjIxMVptLTEuNjM5LDIuM0wxMS4yNTgsMi4yNzUsNC44NzksOC42NTVhLjQ2OC40NjgsMCwwLDAtLjExMy4xODRMNC4wMTIsMTEuMWEuMjM0LjIzNCwwLDAsMCwuMy4zbDIuMjYtLjc1NGEuNDY4LjQ2OCwwLDAsMCwuMTg0LS4xMTJsNi4zNzktNi4zOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMCkiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo=";